import React, { useContext } from 'react'
import { RemoteComponent } from '@contrast-security-inc/design-system-foundations'
import { RouteContext } from '../route-provider'
import { useIntl } from 'react-intl'

const RemotePlatformAuthz = React.lazy(
  // @ts-ignore
  () => import('platformAuthz/app')
)

export const AccessControlSettings = () => {
  const { organizationID } = useContext(RouteContext)
  const { locale } = useIntl()

  return (
    <RemoteComponent testId="access-control-settings">
      <RemotePlatformAuthz
        basename={`/${organizationID}/settings/access`}
        locale={locale}
        orgId={organizationID}
      />
    </RemoteComponent>
  )
}
